export default {
  name: 'PageView',
  inheritAttrs: false,
  data() {
    return {
      route: $$.module.route
      // visible: true,
      // loading: false
    };
  },
  computed: {
    page() {
      const page = this.route[this.route.length - 1];
      return page ? $$.module.get(page) : null;
    }
  },
  render() {
    const Page = this.page;
    return <Page />;
  }
};
